import { Card, CardContent, Stack, Typography, IconButton, CircularProgress } from '@mui/material'
import { Trash2 as DeleteIcon } from 'lucide-react'

import getCreditCardIcon from '@/utils/getCreditCardIcon'

const CARD_STYLES = {
  cursor: 'pointer',
  borderRadius: '12px',
  background: '#FFF',
}

// Payment Method Card Component
export function PaymentMethodCard({
  paymentMethod,
  isSelected,
  onClick,
  onDelete,
  showDelete = false,
  deletingPaymentMethodId,
}) {
  const isDeleting = deletingPaymentMethodId === paymentMethod.id

  const handleDelete = event => {
    event.stopPropagation() // Prevent card selection when clicking delete
    if (!isDeleting) {
      onDelete?.(paymentMethod.id)
    }
  }
  const SELECTED_CARD_STYLES = {
    ...CARD_STYLES,
    border: 2,
    borderColor: 'primary.main',
  }

  const UNSELECTED_CARD_STYLES = {
    ...CARD_STYLES,
    border: 1,
    borderColor: '#EAECF0',
    '&:hover': {
      borderColor: showDelete ? '#EAECF0' : 'primary.main',
    },
  }

  return (
    <Card sx={isSelected && !showDelete ? SELECTED_CARD_STYLES : UNSELECTED_CARD_STYLES} onClick={onClick}>
      <CardContent sx={{ p: '16px !important' }}>
        <Stack alignItems="center" direction="row" gap="16px" justifyContent="space-between">
          <Stack direction="row" flex={1} gap="16px">
            {getCreditCardIcon(paymentMethod.brand)}
            <Stack gap="2px">
              <Typography color="#344054" fontSize={16} fontWeight={500} lineHeight="24px">
                {paymentMethod.brand.toUpperCase()} •••• {paymentMethod.last4}
              </Typography>
              <Typography color="#475467" fontSize={16} fontWeight={400} lineHeight="24px">
                Expires {paymentMethod.exp_month}/{paymentMethod.exp_year}
              </Typography>
            </Stack>
          </Stack>
          {showDelete ? (
            <IconButton
              disabled={isDeleting}
              size="small"
              sx={{
                color: isDeleting ? '#9CA3AF' : '#667085',
                '&:hover': !isDeleting
                  ? {
                      color: '#D92D20',
                      backgroundColor: '#FEF3F2',
                    }
                  : {},
                '&:disabled': {
                  color: '#9CA3AF',
                },
              }}
              onClick={handleDelete}
            >
              {isDeleting ? <CircularProgress size={16} sx={{ color: '#9CA3AF' }} /> : <DeleteIcon size={20} />}
            </IconButton>
          ) : null}
        </Stack>
      </CardContent>
    </Card>
  )
}
